(function () {
  "use strict";

  if (!theme.storeSelectorData) return;

  const MARKET_CONFIG = {
    us: {
      url: "https://sweedbeauty.com/",
      countries: ["US"],
      currency: "USD",
      name: "United States",
    },
    gb: {
      url: "https://sweedbeauty.com/en-gb",
      countries: ["GB"],
      currency: "GBP",
      name: "United Kingdom",
    },
    se: {
      url: "https://sweedbeauty.se/",
      countries: ["SE"],
      currency: "SEK",
      name: "Sweden",
    },
    de: {
      url: "https://sweedbeauty.com/de-de",
      altUrls: {
        en: "https://sweedbeauty.com/en-de",
      },
      countries: ["DE"],
      currency: "EUR",
      name: "Germany",
    },
    nl: {
      url: "https://sweedbeauty.com/nl-nl",
      altUrls: {
        en: "https://sweedbeauty.com/en-nl",
      },
      countries: ["NL"],
      currency: "EUR",
      name: "Netherlands",
    },
    it: {
      url: "https://sweedbeauty.com/it-it",
      altUrls: {
        en: "https://sweedbeauty.com/en-it",
      },
      countries: ["IT"],
      currency: "EUR",
      name: "Italy",
    },
    eu: {
      url: "https://sweedbeauty.eu",
      countries: [
        "AD",
        "AL",
        "AT",
        "AX",
        "BE",
        "BG",
        "HR",
        "CZ",
        "DK",
        "EE",
        "FO",
        "FI",
        "FR",
        "GL",
        "GR",
        "HU",
        "IS",
        "IE",
        "LV",
        "LT",
        "LU",
        "MT",
        "MC",
        "NO",
        "PL",
        "PT",
        "RO",
        "SI",
        "SK",
        "ES",
        "TR",
      ],
      currency: "EUR",
      name: "Europe",
    },
    global: {
      url: "https://sweedbeauty.global",
      countries: ["*"],
      currency: "USD",
      name: "International",
    },
  };

  const GLOBAL_MARKET_COUNTRIES = [
    "AU",
    "CA",
    "NZ",
    "JP",
    "KR",
    "HK",
    "SG",
    "BV",
  ];

  const COUNTRY_TO_MARKET = {};

  Object.entries(MARKET_CONFIG).forEach(([marketId, config]) => {
    if (config.countries[0] === "*") return;
    config.countries.forEach((country) => {
      COUNTRY_TO_MARKET[country] = marketId;
    });
  });

  GLOBAL_MARKET_COUNTRIES.forEach((country) => {
    COUNTRY_TO_MARKET[country] = "global";
  });

  class StoreSelector {
    constructor() {
      this.modal = document.querySelector(".store-selector__modal");
      this.select = this.modal?.querySelector(".store-selector__select");
      this.changeButton = this.modal?.querySelector(
        ".store-selector__change-store-button"
      );

      if (!this.modal || !this.select || !this.changeButton) return;

      this.currentMarket = this.getCurrentMarket();
      this.selectedMarket = this.getSavedMarket() || this.currentMarket;

      this.init();
      this.initExternalTriggers();
    }

    initExternalTriggers() {
      const triggers = document.querySelectorAll(".store-selector__trigger");
      triggers.forEach((trigger) => {
        const dropdownSelect = trigger.querySelector(
          ".store-selector__dropdown-select"
        );
        if (dropdownSelect) {
          dropdownSelect.addEventListener("change", (e) => {
            const value = e.target.value;
            if (value) {
              this.handleSelection(value);
              this.handleRedirect();
            }
          });
        }
      });
    }

    getCurrentMarket() {
      return theme.storeSelectorData.currentMarketHandle || "us";
    }

    getSavedMarket() {
      console.log(
        "Getting saved store from sessionStorage:",
        sessionStorage.getItem("savedStore")
      );
      return sessionStorage.getItem("savedStore");
    }

    saveMarket(marketId) {
      console.log("Saving selected store to sessionStorage:", marketId);
      //const domain = window.location.hostname;
      sessionStorage.setItem("savedStore", marketId);
      /* Cookies.set(`selected-market-${domain}`, marketId, { expires: 365 });
          Cookies.set('store-selector-shown', 'true', { expires: 365 }); */
    }

    /*  hasSeenPopup() {
      return Cookies.get("store-selector-shown") === "true";
    } */

    init() {
      this.select.addEventListener("change", (e) =>
        this.handleSelection(e.target.value)
      );
      this.changeButton.addEventListener("click", () => this.handleRedirect());

      this.setupModalCloseHandlers();

      this.detectUserLocation();

      if (this.selectedMarket) {
        if (
          (this.selectedMarket === "eu" || this.selectedMarket === "global") &&
          !this.detectedCountryCode
        ) {
          setTimeout(() => this.updateUI(this.selectedMarket), 100);
        } else {
          this.updateUI(this.selectedMarket);
        }
      }
    }

    setupModalCloseHandlers() {
      this.modal.addEventListener("click", (e) => {
        if (e.target === this.modal) {
          this.closeModal();
        }
      });

      const closeButton = this.modal.querySelector(".store-selector__close");
      if (closeButton) {
        closeButton.addEventListener("click", () => this.closeModal());
      }

      const modalInner = this.modal.querySelector(
        ".store-selector__modal__inner"
      );
      if (modalInner) {
        modalInner.addEventListener("click", (e) => e.stopPropagation());
      }
    }

    closeModal() {
      this.modal.classList.remove("store-selector__modal--open");
      // Save session cookie (expires when browser closes)
      //Cookies.set("store-selector-session-dismissed", "true");
    }

    handleSelection(value) {
      if (!value) return;

      const option = this.select.querySelector(`option[value="${value}"]`);
      let marketId = value;
      let countryName = null;

      if (option) {
        const optionText = option.textContent.trim();
        const nameMatch = optionText.match(/^(.+?)\s*\(/);
        if (nameMatch) {
          countryName = nameMatch[1].trim();
          countryName = countryName.replace(/\s*-\s*[A-Za-z]+$/, "");
        }

        const valueToMarketMap = {
          se: "se",
          us: "us",
          gb: "gb",
          "de-de": "de",
          "nl-nl": "nl",
          "it-it": "it",
        };

        if (valueToMarketMap[value]) {
          marketId = valueToMarketMap[value];
        } else if (value.startsWith("global-")) {
          const countryCode = value.substring(7);
          marketId = COUNTRY_TO_MARKET[countryCode] || "global";
        }
      }

      this.selectedMarket = marketId;
      this.updateUI(marketId, countryName);
    }

    updateUI(marketId, countryName = null) {
      const config = MARKET_CONFIG[marketId];
      if (!config) return;

      this.select.value = marketId;

      const storeData = this.getStoreDictionary(marketId);

      const displayName = countryName || config.name;

      const elements = {
        title: this.modal.querySelector(".store-selector__modal__title"),
        selectorLabel: this.modal.querySelector(
          ".store-selector__selector-label"
        ),
        description: this.modal.querySelector(
          ".store-selector__description-text"
        ),
        currencyLabel: this.modal.querySelector(
          ".store-selector__currency-label"
        ),
        button: this.changeButton,
        popupTrigger: this.modal.querySelector(
          ".store-selector__popup-trigger"
        ),
        popupText: this.modal.querySelector(".store-selector__popup-text"),
        paymentSwedish: this.modal.querySelector(
          ".store-selector__payment-methods-swedish"
        ),
        paymentInternational: this.modal.querySelector(
          ".store-selector__payment-methods-international"
        ),
      };

      if (elements.title && storeData) {
        let titleText = storeData.modalTitle || `Welcome, we ship to {COUNTRY}`;
        titleText = titleText.replace(/{COUNTRY}/g, displayName);
        elements.title.innerHTML = titleText;
      }

      if (storeData) {
        if (elements.selectorLabel) {
          elements.selectorLabel.textContent =
            storeData.selectLabel || "Select your location";
        }

        if (elements.description) {
          const descriptionText = storeData.description || "";
          elements.description.innerHTML = descriptionText.replace(
            /\n/g,
            "<br>"
          );
        }

        if (elements.currencyLabel) {
          elements.currencyLabel.textContent =
            storeData.currencyLabel || `Currency: ${config.currency}`;
        }

        if (elements.button) {
          let buttonText =
            storeData.changeStoreButton || `Continue to {COUNTRY} store`;
          buttonText = buttonText.replace(/{COUNTRY}/g, displayName);
          elements.button.textContent = buttonText;
        }
      }

      if (elements.popupTrigger && elements.popupText) {
        elements.popupText.textContent = "Change country";
        elements.popupTrigger.classList.add(
          "store-selector__popup-trigger--selected"
        );
      }

      if (elements.paymentSwedish) {
        elements.paymentSwedish.classList.toggle("hide", marketId !== "se");
      }
      if (elements.paymentInternational) {
        elements.paymentInternational.classList.toggle(
          "hide",
          marketId === "se"
        );
      }

      this.updateLanguageSelectors(marketId);
    }

    getStoreDictionary(marketId) {
      if (!theme.storeSelectorData?.dictionaries) return null;

      let dictionary = theme.storeSelectorData.dictionaries.find(
        (d) => d.id.toLowerCase() === marketId.toLowerCase()
      );

      if (!dictionary) {
        const fallbacks = {
          global: ["international", "us"],
          eu: ["ax", "eu"],
        };

        if (fallbacks[marketId]) {
          for (const fallbackId of fallbacks[marketId]) {
            dictionary = theme.storeSelectorData.dictionaries.find(
              (d) => d.id.toLowerCase() === fallbackId.toLowerCase()
            );
            if (dictionary) break;
          }
        }
      }

      return dictionary;
    }

    updateLanguageSelectors(marketId) {
      const languageSelectors = {
        nl: this.modal.querySelector(
          ".store-selector__language-select.nl-language"
        ),
        de: this.modal.querySelector(
          ".store-selector__language-select.de-language"
        ),
        it: this.modal.querySelector(
          ".store-selector__language-select.it-language"
        ),
      };

      Object.values(languageSelectors).forEach((selector) => {
        if (selector) selector.classList.add("hide");
      });
    }

    handleRedirect() {
      console.log("Handling redirect for market:", this.selectedMarket);
      if (!this.selectedMarket) return;

      const config = MARKET_CONFIG[this.selectedMarket];
      if (!config) return;

      this.saveMarket(this.selectedMarket);

      const selectedOption = this.select.options[this.select.selectedIndex];
      const selectedValue = selectedOption?.value;

      let redirectUrl = config.url;

      if (selectedValue && selectedValue.startsWith("global-")) {
        const countryCode = selectedValue.substring(7);

        if (countryCode === "US") {
          redirectUrl = MARKET_CONFIG["us"].url;
        } else if (countryCode === "GB") {
          redirectUrl = MARKET_CONFIG["gb"].url;
        } else if (countryCode === "NL") {
          redirectUrl = MARKET_CONFIG["nl"].url;
        } else if (countryCode === "DE") {
          redirectUrl = MARKET_CONFIG["de"].url;
        } else if (countryCode === "IT") {
          redirectUrl = MARKET_CONFIG["it"].url;
        } else if (MARKET_CONFIG["eu"].countries.includes(countryCode)) {
          redirectUrl = MARKET_CONFIG["eu"].url;
        } else {
          redirectUrl = MARKET_CONFIG["global"].url;
        }
      }

      if (
        this.selectedMarket === "de" ||
        this.selectedMarket === "nl" ||
        this.selectedMarket === "it"
      ) {
        const langConfig = config.altUrls;
        if (langConfig && selectedValue) {
          const langMatch = selectedValue.match(/^(de|nl|it)-(de|nl|it|en)$/);
          if (langMatch && langConfig[langMatch[2]]) {
            redirectUrl = langConfig[langMatch[2]];
          }
        }
      }

      const currentPath = window.location.pathname;
      const productMatch = currentPath.match(/\/products\/([^\/\?]+)/);

      if (productMatch) {
        redirectUrl =
          redirectUrl.replace(/\/$/, "") + `/products/${productMatch[1]}`;
        redirectUrl += window.location.search + window.location.hash;
      }

      window.location.href = redirectUrl;
    }

    detectUserLocation() {
      // Check if user has dismissed popup in this session
      if (Cookies.get("store-selector-session-dismissed") === "true") {
        return;
      }

      fetch("https://ipapi.co/json/", { signal: AbortSignal.timeout(3000) })
        .then((response) => response.json())
        .then((data) => {
          if (!data.country_code) return;

          const countryCode = data.country_code.toUpperCase();
          const countryName = data.country_name;
          const detectedMarket = COUNTRY_TO_MARKET[countryCode] || "global";

          this.detectedCountryCode = countryCode;
          this.detectedCountryName = countryName;
          const savedMarket = this.getSavedMarket();
          console.log("store selector:", {
            currentMarket: this.currentMarket,
            savedStore: savedMarket,
            detectedMarket: detectedMarket,
          });
          const exceptionCountries = ["BA", "BY", "AL", "SM", "XK", "IS"];
          if (exceptionCountries.includes(countryCode)) {
            const descElement = this.modal.querySelector(
              ".store-selector__description-text"
            );
            if (descElement) descElement.style.display = "none";
          }

          // Show popup only if detected market doesn't match current market
          if (detectedMarket !== this.currentMarket) {
            if (this.currentMarket !== sessionStorage.getItem("savedStore")) {
              let valueToSelect = detectedMarket;

              if (detectedMarket === "eu" || detectedMarket === "global") {
                valueToSelect = `global-${countryCode}`;
                const specificOption = this.select.querySelector(
                  `option[value="${valueToSelect}"]`
                );

                if (specificOption) {
                  this.selectedMarket = detectedMarket;
                  this.select.value = valueToSelect;
                  this.updateUI(detectedMarket, countryName);
                } else {
                  this.selectedMarket = detectedMarket;
                  this.updateUI(detectedMarket, countryName);
                }
              } else {
                this.selectedMarket = detectedMarket;
                this.updateUI(detectedMarket);
              }

              this.modal.classList.add("store-selector__modal--open");

              if (theme.storeSelectorData?.isLandingStoreSelectorEnabled) {
                this.modal.classList.add("store-selector__landing-layer");
              }
            }
          } else {
            // User is on correct market, just update UI if needed
            if (
              (this.currentMarket === "eu" ||
                this.currentMarket === "global") &&
              this.selectedMarket === this.currentMarket
            ) {
              this.updateUI(this.currentMarket, countryName);
            }
          }
        })
        .catch((error) => {
          console.log("IP detection failed:", error);
        });
    }
  }

  new StoreSelector();
})();
